import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps } from 'intergalactic/core';
import React from 'react';
import createComponent, { Component, Root, sstyled } from 'intergalactic/core';
import { Box } from 'intergalactic/flex-box';
import contextEnhance from 'intergalactic/utils/lib/enhances/contextEnhance';
/*__reshadow-styles__:"./style/animate.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SAnimation_q949w_gg_{animation-fill-mode:both;animation-timing-function:var(--timingFunction_q949w);animation-duration:var(--durationFinalize_q949w);animation-delay:var(--delayFinalize_q949w);animation-name:var(--keyframesFinalize_q949w)}.___SAnimation_q949w_gg_.__transition-based_q949w_gg_{transition-timing-function:var(--timingFunction_q949w);transition-duration:var(--durationFinalize_q949w);transition-delay:var(--delayFinalize_q949w)}.___SAnimation_q949w_gg_.__visible_q949w_gg_{animation-duration:var(--durationInitialize_q949w);animation-delay:var(--delayInitialize_q949w);animation-name:var(--keyframesInitialize_q949w)}.___SAnimation_q949w_gg_.__visible_q949w_gg_.__transition-based_q949w_gg_{transition-timing-function:var(--timingFunction_q949w);transition-duration:var(--durationInitialize_q949w);transition-delay:var(--delayInitialize_q949w)}@media (prefers-reduced-motion){.___SAnimation_q949w_gg_.__transition-based_q949w_gg_,.___SAnimation_q949w_gg_.__visible_q949w_gg_.__transition-based_q949w_gg_{transition-timing-function:none;transition-duration:none;transition-delay:none}.___SAnimation_q949w_gg_,.___SAnimation_q949w_gg_.__visible_q949w_gg_{animation-timing-function:step-end;animation-iteration-count:1}}" /*__inner_css_end__*/, "q949w_gg_") /*__reshadow_css_end__*/, {
  "__SAnimation": "___SAnimation_q949w_gg_",
  "--timingFunction": "--timingFunction_q949w",
  "--durationFinalize": "--durationFinalize_q949w",
  "--delayFinalize": "--delayFinalize_q949w",
  "--keyframesFinalize": "--keyframesFinalize_q949w",
  "_transition-based": "__transition-based_q949w_gg_",
  "_visible": "__visible_q949w_gg_",
  "--durationInitialize": "--durationInitialize_q949w",
  "--delayInitialize": "--delayInitialize_q949w",
  "--keyframesInitialize": "--keyframesInitialize_q949w"
});
function propToArray(prop) {
  return Array.isArray(prop) ? prop : [prop, prop];
}
var makeAnimationContextValue = function makeAnimationContextValue() {
  var context = {
    onAnimationStartSubscribers: [],
    onAnimationStart: function onAnimationStart(callback) {
      context.onAnimationStartSubscribers.push(callback);
      return function () {
        return context.onAnimationStartSubscribers.filter(function (cb) {
          return cb !== callback;
        });
      };
    },
    onAnimationEndSubscribers: [],
    onAnimationEnd: function onAnimationEnd(callback) {
      context.onAnimationEndSubscribers.push(callback);
      return function () {
        return context.onAnimationEndSubscribers.filter(function (cb) {
          return cb !== callback;
        });
      };
    }
  };
  return context;
};
export var animationContext = /*#__PURE__*/React.createContext(null);
var Animation = /*#__PURE__*/function (_Component) {
  _inherits(Animation, _Component);
  var _super = _createSuper(Animation);
  function Animation() {
    var _this;
    _classCallCheck(this, Animation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      animationRunning: false,
      render: _this.props.visible || _this.props.preserveNode,
      wasInvisible: !_this.props.visible
    });
    _defineProperty(_assertThisInitialized(_this), "animationSupported", false);
    _defineProperty(_assertThisInitialized(_this), "animationContext", makeAnimationContextValue());
    _defineProperty(_assertThisInitialized(_this), "onAnimationStart", function () {
      _this.animationSupported = true;
      var _this$asProps = _this.asProps,
        animationsDisabled = _this$asProps.animationsDisabled,
        parentAnimationContext = _this$asProps.parentAnimationContext;
      var duration = animationsDisabled ? [0, 0] : propToArray(_this.asProps.duration);
      var animationContext = parentAnimationContext !== null && parentAnimationContext !== void 0 ? parentAnimationContext : _this.animationContext;
      animationContext.onAnimationStartSubscribers.forEach(function (callback) {
        return callback(duration[0]);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onAnimationEnd", function (event) {
      _this.animationSupported = true;
      _this.handleAnimationEnd();
    });
    _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function () {
      if (!_this.asProps.visible && !_this.props.preserveNode) {
        _this.setState({
          render: false
        });
      }
      var parentAnimationContext = _this.asProps.parentAnimationContext;
      var animationContext = parentAnimationContext !== null && parentAnimationContext !== void 0 ? parentAnimationContext : _this.animationContext;
      animationContext.onAnimationEndSubscribers.forEach(function (callback) {
        return callback();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "animationEventFallback", function () {
      if (!_this.state.render) return;
      if (_this.animationSupported) return;
      var delayArr = _this.asProps.animationsDisabled ? [0, 0] : propToArray(_this.asProps.delay);
      var delay = _this.asProps.visible ? delayArr[0] : delayArr[1];
      var duration = _this.asProps.animationsDisabled ? 0 : _this.asProps.duration + 100;
      setTimeout(function () {
        if (_this.animationSupported) return;
        _this.handleAnimationEnd();
      }, duration + delay);
    });
    return _this;
  }
  _createClass(Animation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animationEventFallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.visible !== this.props.visible || prevState.render !== this.state.render) {
        this.animationEventFallback();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.asProps,
        _ref2;
      var SAnimation = Box;
      var _this$asProps2 = this.asProps,
        styles = _this$asProps2.styles,
        keyframes = _this$asProps2.keyframes,
        initialAnimation = _this$asProps2.initialAnimation,
        timingFunction = _this$asProps2.timingFunction,
        animationsDisabled = _this$asProps2.animationsDisabled,
        parentAnimationContext = _this$asProps2.parentAnimationContext;
      var animationContextValue = parentAnimationContext !== null && parentAnimationContext !== void 0 ? parentAnimationContext : this.animationContext;
      var duration = animationsDisabled ? [0, 0] : propToArray(this.asProps.duration);
      var delay = animationsDisabled ? [0, 0] : propToArray(this.asProps.delay);
      var _this$state = this.state,
        render = _this$state.render,
        wasInvisible = _this$state.wasInvisible;
      if (!render) return null;
      return /*#__PURE__*/React.createElement(animationContext.Provider, {
        value: animationContextValue
      }, (_ref2 = sstyled(styles), /*#__PURE__*/React.createElement(SAnimation, _ref2.cn("SAnimation", _objectSpread({}, _assignProps({
        "onAnimationStart": this.onAnimationStart,
        "onAnimationEnd": this.onAnimationEnd,
        "durationInitialize": "".concat(duration[0], "ms"),
        "durationFinalize": "".concat(duration[1], "ms"),
        "delayInitialize": "".concat(delay[0], "ms"),
        "delayFinalize": "".concat(delay[1], "ms"),
        "timingFunction": timingFunction,
        "keyframesInitialize": wasInvisible || initialAnimation ? keyframes[0] : 'totally-no-animations',
        "keyframesFinalize": keyframes[1]
      }, _ref))))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var wasInvisible = state.wasInvisible || !props.visible;
      if (props.visible || props.preserveNode || state.wasInvisible !== wasInvisible) {
        return {
          render: true,
          wasInvisible: wasInvisible
        };
      }
      return state;
    }
  }]);
  return Animation;
}(Component);
_defineProperty(Animation, "displayName", 'Animation');
_defineProperty(Animation, "style", style);
_defineProperty(Animation, "defaultProps", {
  visible: false,
  duration: 0,
  delay: 0,
  keyframes: [],
  initialAnimation: false,
  timingFunction: 'ease-out',
  animationsDisabled: false
});
_defineProperty(Animation, "enhance", [contextEnhance(animationContext, 'parentAnimationContext')]);
export default createComponent(Animation);
//# sourceMappingURL=Animation.js.map